// extracted by mini-css-extract-plugin
export default {"authPage":"styles_auth-page__tNy5h"};